import axios from "src/utils/axios";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
    getUser: "/profile/info",
    updateUser: "/profile/update",
    //
    resetPassword: "/profile/reset_password",
    //
    setRestoreID: "/user_chat/update_restore_id",
    getRestoreID: "/user_chat/get_restore_id"
};

// ----------------------------------------------------------------------

const getUser = () => axios.get(API_ENDPOINTS.getUser);

const updateUser = (request) => axios.post(API_ENDPOINTS.updateUser, { ...request });

const resetPassword = (request) => axios.post(API_ENDPOINTS.resetPassword, { ...request });

const updateRestoreID = (id) => axios.post(API_ENDPOINTS.setRestoreID, { restore_id: id });


export {
    getUser as getUserAPI,
    updateUser as updateUserAPI,
    //
    resetPassword as resetPasswordAPI,
    //
    updateRestoreID as updateRestoreIDAPI
};
